import React from 'react';
import { injectIntl } from 'react-intl';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

/**
 * Componente que muestra un tooltip informativo cuando un servicio tiene validación automática
 * @param {Object} element - El elemento que puede tener validacion_automatica o servicio.validacion_automatica
 * @param {Object} intl - Objeto de internacionalización de react-intl
 * @param {Boolean} checkConfig - Si debe verificar la configuración de autoAprobacion (default: true)
 */
const ValidacionAutomaticaTooltip = ({ element, intl, checkConfig = true }) => {
	// Verificar si debe mostrar el tooltip
	const shouldShow = () => {
		// Verificar si el servicio tiene validación automática o el elemento mismo
		const hasValidacionAutomatica = 
			(element.servicio && element.servicio.validacion_automatica === 1) || 
			element.validacion_automatica === 1;
		
		// Si checkConfig es true, también verificar la configuración
		if (checkConfig) {
			return hasValidacionAutomatica && 
				ConfigBusiness.get('tickets.presupuesto.servicios.autoAprobacion') === 'true';
		}
		
		return hasValidacionAutomatica;
	};

	if (!shouldShow()) {
		return null;
	}

	return (
		<span 
			className="ml-2 text-info" 
			data-tooltip="tooltip" 
			data-placement="top"
			title={intl.formatMessage({ 
				id: 'Servicio_con_validacion_automatica_sin_tope_de_monto', 
				defaultMessage: 'Servicio con validación automática sin tope de monto' 
			})}
			style={{cursor: 'pointer'}}
		>
			<i className="fa fa-info-circle"></i>
		</span>
	);
};

export default injectIntl(ValidacionAutomaticaTooltip);

